module.exports = __webpack_public_path__ + "fonts/AvenirNextCyr-Italic.117d31c7.ttf";